/*================================================================================================================
*                                                  Rights
* ==============================================================================================================*/

// users
export const GET_USER_KEY = 'user';
export const GET_USERS_KEY = 'users';
export const GET_USERS_WITH_EMAIL_KEY = 'usersWithEmail';
export const UPSERT_USERS_KEY = 'upsertUser';
export const LINK_USER_GOOGLE_ACCOUNT = 'linkUserGoogleAccount';
export const UNLINK_USER_GOOGLE_ACCOUNT = 'unlinkUserGoogleAccount';
export const UPDATE_EMPLOYEE_CREDENTIALS = 'updateEmployeeCredentials';
export const RESET_EMPLOYEE_CREDENTIALS = 'resetEmployeeCredentials';
export const LOGOUT_USERS_KEY = 'logoutUsers';
export const LOGOUT_ALL_USERS_KEY = 'logoutAllUsers';
export const DELETE_USER_KEY = 'deleteUser';
export const UPDATE_USER_ACCESS_POINTS = 'updateUserAccessPoints';

// rights
export const GET_RIGHTS_KEY = 'rights';
export const UPSERT_RIGHT_KEY = 'upsertRight';
export const DELETE_RIGHT_KEY = 'deleteRight';

// roles
export const GET_ROLES_KEY = 'roles';
export const UPSERT_ROLE_KEY = 'upsertRole';
export const DELETE_ROLE_KEY = 'deleteRole';

/*================================================================================================================
*                                                    Master Data
* ==============================================================================================================*/

// Division
export const GET_DIVISIONS_KEY = 'divisions';
export const UPSERT_DIVISION_KEY = 'upsertDivision';
export const DELETE_DIVISION_KEY = 'deleteDivision';

// Access Point
export const GET_ACCESS_POINTS_KEY = 'accessPoints';
export const UPSERT_ACCESS_POINT_KEY = 'upsertAccessPoint';
export const DELETE_ACCESS_POINT_KEY = 'deleteAccessPoint';

// Access Point Categories
export const GET_ACCESS_POINT_CATEGORIES_KEY = 'accessPointCategories';
export const UPSERT_ACCESS_POINT_CATEGORY_KEY = 'upsertAccessPointCategory';
export const DELETE_ACCESS_POINT_CATEGORY_KEY = 'deleteAccessPointCategory';

// Bail Application
export const GET_BAIL_APPLICATIONS_KEY = 'bailApplications';
export const UPSERT_BAIL_APPLICATION_KEY = 'upsertBailApplication';
export const DELETE_BAIL_APPLICATION_KEY = 'deleteBailApplication';

// Bail Verdict
export const GET_BAIL_VERDICTS_KEY = 'bailVerdicts';
export const UPSERT_BAIL_VERDICT_KEY = 'upsertBailVerdict';
export const DELETE_BAIL_VERDICT_KEY = 'deleteBailVerdict';

// Division Type
export const GET_DIVISION_TYPES_KEY = 'divisionTypes';
export const UPSERT_DIVISION_TYPE_KEY = 'upsertDivisionType';
export const DELETE_DIVISION_TYPE_KEY = 'deleteDivisionType';

// Employee
export const GET_EMPLOYEES_KEY = 'employees';
export const UPSERT_EMPLOYEE_KEY = 'upsertEmployee';
export const DELETE_EMPLOYEE_KEY = 'deleteEmployee';

// Grave
export const GET_GRAVES_KEY = 'graves';
export const UPSERT_GRAVE_KEY = 'upsertGrave';
export const DELETE_GRAVE_KEY = 'deleteGrave';

// Grave Site
export const GET_GRAVE_SITES_KEY = 'graveSites';
export const UPSERT_GRAVE_SITE_KEY = 'upsertGraveSite';
export const DELETE_GRAVE_SITE_KEY = 'deleteGraveSite';

// Grave Visit Reason
export const GET_GRAVE_VISIT_REASONS_KEY = 'graveVisitReasons';
export const UPSERT_GRAVE_VISIT_REASON_KEY = 'upsertGraveVisitReason';
export const DELETE_GRAVE_VISIT_REASON_KEY = 'deleteGraveVisitReason';

// Incident Category
export const GET_INCIDENT_CATEGORIES_KEY = 'incidentCategories';
export const UPSERT_INCIDENT_CATEGORY_KEY = 'upsertIncidentCategory';
export const DELETE_INCIDENT_CATEGORY_KEY = 'deleteIncidentCategory';

// Incident Group
export const GET_INCIDENT_GROUPS_KEY = 'incidentGroups';
export const UPSERT_INCIDENT_GROUP_KEY = 'upsertIncidentGroup';
export const DELETE_INCIDENT_GROUP_KEY = 'deleteIncidentGroup';

// Power Source
export const GET_POWER_SOURCES_KEY = 'powerSources';
export const UPSERT_POWER_SOURCE_KEY = 'upsertPowerSource';
export const DELETE_POWER_SOURCE_KEY = 'deletePowerSource';

// Region
export const GET_REGIONS_KEY = 'regions';
export const UPSERT_REGION_KEY = 'upsertRegion';
export const DELETE_REGION_KEY = 'deleteRegion';

// SAPS stations
export const GET_SAPS_STATION_KEY = 'sapsStation';
export const GET_SAPS_STATIONS_KEY = 'sapsStations';
export const UPSERT_SAPS_STATION_KEY = 'upsertSapsStation';
export const IMPORT_SAPS_STATION_KEY = 'importSapsStation';
export const DELETE_SAPS_STATION_KEY = 'deleteSapsStation';

// Province
export const GET_PROVINCES_KEY = 'provinces';
export const UPSERT_PROVINCE_KEY = 'upsertProvince';
export const DELETE_PROVINCE_KEY = 'deleteProvince';

// Language
export const GET_LANGUAGES_KEY = 'language';
export const UPSERT_LANGUAGE_KEY = 'upsertLanguage';
export const DELETE_LANGUAGE_KEY = 'deleteLanguage';

// House Breaking Entry Point
export const GET_HOUSE_BREAKING_ENTRY_POINTS_KEY = 'houseBreakingEntryPoints';
export const UPSERT_HOUSE_BREAKING_ENTRY_POINT_KEY = 'upsertHouseBreakingEntryPoint';
export const DELETE_HOUSE_BREAKING_ENTRY_POINT_KEY = 'deleteHouseBreakingEntryPoint';

// Poaching Methods
export const GET_POACHING_METHODS_KEY = 'poachingMethods';
export const UPSERT_POACHING_METHODS_KEY = 'upsertPoachingMethod';
export const DELETE_POACHING_METHODS_KEY = 'deletePoachingMethod';

// Vehicle Ownerships
export const GET_VEHICLE_OWNERSHIPS_KEY = 'vehicleOwnerships';
export const UPSERT_VEHICLE_OWNERSHIPS_KEY = 'upsertVehicleOwnership';
export const DELETE_VEHICLE_OWNERSHIPS_KEY = 'deleteVehicleOwnership';

// Weather conditions
export const GET_WEATHER_CONDITIONS_KEY = 'weatherConditions';
export const UPSERT_WEATHER_CONDITIONS_KEY = 'upsertWeatherCondition';
export const DELETE_WEATHER_CONDITIONS_KEY = 'deleteWeatherCondition';

// Officer Types
export const GET_OFFICER_TYPES_KEY = 'officerTypes';
export const UPSERT_OFFICER_TYPE_KEY = 'upsertOfficerType';
export const DELETE_OFFICER_TYPE_KEY = 'deleteOfficerType';

// Accredited Training
export const GET_ACCREDITED_TRAININGS_KEY = 'accreditedTrainings';
export const UPSERT_ACCREDITED_TRAINING_KEY = 'upsertAccreditedTraining';
export const DELETE_ACCREDITED_TRAINING_KEY = 'deleteAccreditedTraining';

// Officer Groups
export const GET_OFFICER_GROUPS_KEY = 'officerGroups';
export const UPSERT_OFFICER_GROUP_KEY = 'upsertOfficerGroup';
export const DELETE_OFFICER_GROUP_KEY = 'deleteOfficerGroup';

// Nature Of Service
export const GET_NATURE_OF_SERVICES_KEY = 'natureOfServices';
export const UPSERT_NATURE_OF_SERVICE_KEY = 'upsertNatureOfService';
export const DELETE_NATURE_OF_SERVICE_KEY = 'deleteNatureOfService';

/*================================================================================================================
*                                             Dev Tools Master Data
* ==============================================================================================================*/

// Logging
export const GET_LOGS_KEY = 'logs';

// Auth Sync
export const GET_AUTH_SYNC_STATUS = 'syncAuthStatus';
export const SET_AUTH_SYNC_STATUS = 'setAuthSyncStatus';
export const TRIGGER_AUTH_FULL_SYNC = 'fullAuthSync';

// Contact Us
export const GET_CONTACTS_KEY = 'contacts';
export const UPSERT_CONTACT_KEY = 'upsertContact';
export const DELETE_CONTACT_KEY = 'deleteContact';

// News
export const GET_NEWS_KEY = 'news';
export const UPSERT_NEWS_KEY = 'upsertNews';
export const DELETE_NEWS_KEY = 'deleteNews';

// Frequently Asked Question
export const GET_FREQUENTLY_ASKED_QUESTIONS_KEY = 'frequentlyAskedQuestions';
export const UPSERT_FREQUENTLY_ASKED_QUESTION_KEY = 'upsertFrequentlyAskedQuestion';
export const DELETE_FREQUENTLY_ASKED_QUESTION_KEY = 'deleteFrequentlyAskedQuestion';

/*================================================================================================================
*                                                    Fresh Service
* ==============================================================================================================*/

export const UPSERT_FRESH_SERVICE_TICKET = 'upsertFreshServiceTicket';

/*================================================================================================================
*                                                  Transactional
* ==============================================================================================================*/

// Observation
export const GET_OBSERVATIONS_KEY = 'observations';
export const UPSERT_OBSERVATION_KEY = 'upsertObservation';
export const DELETE_OBSERVATION_KEY = 'deleteObservation';

// Occurrence
export const GET_OCCURRENCES_KEY = 'occurrences';
export const UPSERT_OCCURRENCE_KEY = 'upsertOccurrence';
export const DELETE_OCCURRENCE_KEY = 'deleteOccurrence';

// Incident
export const GET_INCIDENT_KEY = 'incident';
export const GET_INCIDENTS_KEY = 'incidents';
export const UPSERT_INCIDENT_KEY = 'upsertIncident';
export const UPDATE_INCIDENT_KEY = 'updateIncident';
export const APPROVE_INCIDENT_KEY = 'approveIncident';
export const DISAPPROVE_INCIDENT_KEY = 'disapproveIncident';
export const DELETE_INCIDENT_KEY = 'deleteIncident';

// Incident Docket
export const GET_INCIDENT_DOCKET_KEY = 'incidentDocket';
export const UPSERT_INCIDENT_DOCKET_KEY = 'upsertIncidentDocket';
export const DELETE_INCIDENT_DOCKET_KEY = 'deleteIncidentDocket';

// Access Point Event
export const GET_ACCESS_POINT_EVENTS_KEY = 'accessPointEvents';
export const UPSERT_ACCESS_POINT_EVENT_KEY = 'upsertAccessPointEvent';
export const DELETE_ACCESS_POINT_EVENT_KEY = 'deleteAccessPointEvent';

// Grave Visit
export const GET_GRAVE_VISITS_KEY = 'graveVisits';
export const UPSERT_GRAVE_VISIT_KEY = 'upsertGraveVisit';
export const DELETE_GRAVE_VISIT_KEY = 'deleteGraveVisit';
